<picture class="page-background">
  <source media="(min-width: 840px)" srcset="assets/images/backgrounds/background-02_large.jpg" />
  <source media="(min-width: 600px)" srcset="assets/images/backgrounds/background-02_medium.jpg" />
  <source media="(max-width: 599px)" srcset="assets/images/backgrounds/background-02_small.jpg" />
  <img class="cover" src="assets/images/backgrounds/background-02_large.jpg" alt="">
</picture>
  <ng-container>
    <ecp-contact-forgot-password></ecp-contact-forgot-password>
  </ng-container>
